module.exports = __webpack_public_path__ + "img/c2.4d6fbf4e.png";